





























































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  DrivewealthAccountManagementType, InvestmentFeeSchedule, InvestmentManagementType
} from "@/shared/types";
import _ from "lodash";
import { formatCurrency } from "@/shared/currency";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InvestmentAccountTypeFeeDetails from "@/shared/components/investments/drivewealth/InvestmentAccountTypeFeeDetails.vue";
import InvestmentFeeDisclaimer from "@/employee/components/investments/drivewealth/InvestmentFeeDisclaimer.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { Location } from "vue-router";
import { useUserStore } from "@/shared/store/user";

const accountTypeOrdering = {
  RIA_MANAGED: 0,
  ADVISORY: 1,
  SELF: 2
};

@Component({
  components: {
    GenericLoadingSpinner,
    DrivewealthNavigation,
    InvestmentAccountTypeFeeDetails,
    InvestmentFeeDisclaimer,
    AccountTypeSubheader
  }
})
export default class DrivewealthFees extends Vue {
  @Prop() accountId: number;

  @Prop() routeToDrivewealthFeesV2: (
      dwAccountId: number,
      partnerId: number, username: string) => Location;
  @Prop({ required: false })
  username: string;
  @Prop({ required: false })
  partnerId: number;

  drivewealthStore = useDrivewealthStore();
  custodianSettingsStore = useCustodianSettingsStore();
  enrollmentStore = useEnrollmentStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  userStore = useUserStore();

  formatCurrency = formatCurrency;

  mounted (): void {
    this.enrollmentStore.loadFees();
    this.drivewealthWizardStore.loadAllowedInvestmentAccountTypes({});
  }

  get investmentFees (): InvestmentFeeSchedule[] {
    const feeSchedule = this.enrollmentStore.feeSchedule;

    if (!feeSchedule.investmentFees.length) {
      return [];
    }

    const sortedInvestmentFees = feeSchedule.investmentFees.sort((a, b) => {
      return accountTypeOrdering[a.accountType] - accountTypeOrdering[b.accountType];
    });

    const allowedInvestmentTypeDictionary = {
      RIA_MANAGED: this.drivewealthWizardStore.enrollmentType.hasRiaManaged,
      ADVISORY: this.drivewealthWizardStore.enrollmentType.hasAdvisory,
      SELF: this.drivewealthWizardStore.enrollmentType.hasSelfDirected
    };

    return sortedInvestmentFees.filter(x => {
      const isAccountTypeEnabled = allowedInvestmentTypeDictionary[x.accountType];

      if (isAccountTypeEnabled) {
        return x;
      }
    });
  }

  convertedAccountType (internalAccountType: string): DrivewealthAccountManagementType {
    switch (internalAccountType) {
      case InvestmentManagementType.Managed: {
        return DrivewealthAccountManagementType.RiaManaged;
      }
      case InvestmentManagementType.Advisory: {
        return DrivewealthAccountManagementType.Advisory;
      }
      case InvestmentManagementType.SelfDirected: {
        return DrivewealthAccountManagementType.OpenBrokerage;
      }
    }
  }

  iconType (accountManagementType: DrivewealthAccountManagementType): string {
    switch (accountManagementType) {
      case DrivewealthAccountManagementType.Advisory:
        return "fa-sliders";
      case DrivewealthAccountManagementType.OpenBrokerage:
        return "fa-list-check";
      case DrivewealthAccountManagementType.RiaManaged:
        return "fa-handshake";
      default:
        return "fa-sliders";
    }
  }

  get isEmployerPortal (): boolean {
    return this.userStore.isEmployerPortal;
  }
}
